<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BatchBillingListEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="fulfillment_date"
        :label="'Fulfillment Date'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="fulfillment_date_enabled"
              v-model="item.$updates.fulfillment_date"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          name="fulfillment_date"
          v-model="item.fulfillment_date"
          :disabled="!item.$updates.fulfillment_date"
          class="w-auto"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="due_date"
        :label="'Due Date'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        required
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="due_date_enabled"
              v-model="item.$updates.due_date"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          class="w-auto"
          name="due_date"
          v-model="item.due_date"
          :disabled="!item.$updates.due_date"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="billing_period"
        :label="'Billing Period'|gettext"
        contentClass="input-group"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        v-if="item.billing_period"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="billing_period_enabled"
              v-model="item.$updates.billing_period"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <div
          class="form-row"
        >
          <DIV
            class="col-4"
          >
            <ItpFormDatetime
              name="billing_period_start"
              v-model="item.billing_period.start"
              :placeholder="'From'|pgettext('BillingPeriod')"
              :disabled="!item.$updates.billing_period"
            >
            </ItpFormDatetime>
          </DIV>
          <DIV
            class="col-4"
          >
            <ItpFormDatetime
              name="billing_period_end"
              v-model="item.billing_period.end"
              :placeholder="'To'|pgettext('BillingPeriod')"
              :disabled="!item.$updates.billing_period"
            >
            </ItpFormDatetime>
          </DIV>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="currency"
        :label="'Currency'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="3"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="currency_enabled"
              v-model="item.$updates.currency"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect
          name="currency"
          v-model="item.currency"
          :options="currencies"
          valueField="code"
          textField="code"
          :disabled="!item.$updates.currency"
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <ItpFormGroup
        name="currency"
        :label="'Exchange rate'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="exchange_rate_enabled"
              v-model="item.$updates.exchange_rate"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <div
          class="form-row"
        >
          <DIV
            class="col-3"
          >
            <ItpFormInput
              mask="number"
              unmask="typed"
              scale="2"
              name="exchange_rate"
              v-model="exchange_rate.value"
              :readonly="isReadonly"
              :placeholder="'Rate'|pgettext('Invoice')"
              :disabled="!item.$updates.exchange_rate"
              @blur="evh_4397690859646801_blur($event, {})"
            >
            </ItpFormInput>
          </DIV>
          <DIV
            class="col-4"
          >
            <ItpFormDatetime
              name="exchange_rate_date"
              v-model="exchange_rate.date"
              :readonly="isReadonly"
              :placeholder="'Date'|pgettext('Invoice')"
              :disabled="!item.$updates.exchange_rate"
              @blur="evh_4067533979448964_blur($event, {})"
            >
            </ItpFormDatetime>
          </DIV>
          <DIV
            class="col-5"
          >
            <ItpFormSelect
              name="exchange_rate_source"
              v-model="exchange_rate.source"
              :options="exchangeRateSources"
              :readonly="isReadonly"
              :placeholder="'Source'|pgettext('ExchangeRateFieldset')"
              valueField="value"
              textField="name"
              null-option
              :disabled="!item.$updates.exchange_rate"
              @blur="evh_8826227742204642_blur($event, {})"
            >
            </ItpFormSelect>
          </DIV>
        </div>
      </ItpFormGroup>
      <hr
        class="my-4"
      >
      </hr>
      <ItpFormGroup
        name="notes"
        :label="'Notes'|pgettext('Invoice')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="notes_enabled"
              v-model="item.$updates.notes"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormTextarea
          name="notes"
          v-model="item.notes"
          :disabled="!item.$updates.notes"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BatchBillingListEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getItemFromSources(...args: any[]) {
    const [items, fields] = args;
    const fieldNames = _.map(fields, 'name');

    let result = {}

    _.each(items, (item, i) => {
      if (i === 0) {
        result = _.pick(item, fieldNames);
      }

      for (const { name, defaultValue } of fields) {
        if (result[name] != item[name]) {
          result[name] = defaultValue;
          continue;
        }

        if (_.isUndefined(result[name])) {
          result[name] = defaultValue;
          continue;
        }

        if (result[name] != null) {
          result[name] = item[name];
        }
      }
    });

    result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {})
    return result;
  }

  getPayload(...args: any[]) {
    const [items, item] = args;

    const updates = _.keys(_.pickBy(item.$updates, _.identity));

    if (!updates.length) {
      return
    }

    const update = _.pick(item, updates)

    return {
      items: _.map(items, p => ({
        id: p.id,
        etag: p.etag,
        value: update
      }))
    };
  }

  syncExchangeRate(...args: any[]) {
    const v = this.exchange_rate
    this.item.exchange_rate = v.value == null ? null : v
  }

  @Prop({
    type: Array,
  })
  items!: array;

  @Watch('items')
  onItems(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("items")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  isReadonly!: any;
  exchange_rate!: any;

  async $$load_exchange_rate() {
    return { value: null, date: null, source: null }
  }

  exchangeRateSources!: any;

  async $$load_exchangeRateSources() {
    return this.$app.repo.get('ui_metadata', { path: 'exchange_rate_source_options' })
  }

  editableFields!: any;
  labelAlign!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;

  async $$load_item() {
    return this.getItemFromSources(this.items, this.$data.editableFields)
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['isReadonly', 'exchange_rate', 'exchangeRateSources', 'editableFields', 'labelAlign', 'formId', 'formName', 'item', 'currencies', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        isReadonly: false,
        exchange_rate: null,
        exchangeRateSources: null,
        editableFields: [{
          name: "fulfillment_date",
        }
          ,
        {
          name: "due_date",
        }
          ,
        {
          name: "currency",
        }
          ,
        {
          name: "exchange_rate",
        }
          ,
        {
          name: "billing_period",
          defaultValue: {
            start: null,
            end: null,
          }
          ,
        }
          ,
        ]
        ,
        labelAlign: "right",
        formId: null,
        formName: "BatchBillingListEdit",
        item: null,
        currencies: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("BatchBillingListEditor|Title", "Batch Edit Billint List Items"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2108_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2108, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_2114_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_2114, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_request_2112_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_2112, alias=save
    return {
      operation: "bulk_update_billing_list_item",
      data: this.getPayload(this.items, this.item),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_4397690859646801_script_2116_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4397690859646801_script_2116, alias=undefined
    this.syncExchangeRate()
  }

  async act_4397690859646801_script_2116_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4397690859646801_script_2116, alias=undefined
    return {
      value: () => this.act_4397690859646801_script_2116_getActionArgs_value($event),
    }
  }

  async evh_4397690859646801_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4397690859646801_blur.executeFromDOM(this, event, scope);
  }

  async act_4067533979448964_script_2118_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4067533979448964_script_2118, alias=undefined
    this.syncExchangeRate()
  }

  async act_4067533979448964_script_2118_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4067533979448964_script_2118, alias=undefined
    return {
      value: () => this.act_4067533979448964_script_2118_getActionArgs_value($event),
    }
  }

  async evh_4067533979448964_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4067533979448964_blur.executeFromDOM(this, event, scope);
  }

  async act_8826227742204642_script_2120_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8826227742204642_script_2120, alias=undefined
    this.syncExchangeRate()
  }

  async act_8826227742204642_script_2120_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8826227742204642_script_2120, alias=undefined
    return {
      value: () => this.act_8826227742204642_script_2120_getActionArgs_value($event),
    }
  }

  async evh_8826227742204642_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8826227742204642_blur.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2108: actions.CloseModalAction;
    evh_7315092382398562_close_2107: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2110: actions.CloseComponentAction;
    evh_2248226175642056_close_2109: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_2114: actions.CloseModalAction;
    evh_1040167445267876_success_2113: actions.EventHandlerImpl;
    act_1040167445267876_request_2112: actions.RequestAction;
    evh_1040167445267876_submit_2111: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_4397690859646801_script_2116: actions.ScriptAction;
    evh_4397690859646801_blur_2115: actions.EventHandlerImpl;
    evh_4397690859646801_blur: actions.EventHandlerGroup;
    act_4067533979448964_script_2118: actions.ScriptAction;
    evh_4067533979448964_blur_2117: actions.EventHandlerImpl;
    evh_4067533979448964_blur: actions.EventHandlerGroup;
    act_8826227742204642_script_2120: actions.ScriptAction;
    evh_8826227742204642_blur_2119: actions.EventHandlerImpl;
    evh_8826227742204642_blur: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_2122: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_2121: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2108 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2108_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2107 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2108,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2107],
      }
    );
    const act_2248226175642056_closeComponent_2110 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2109 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2110,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2109],
      }
    );
    const act_1040167445267876_closeModal_2114 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_2114_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2113 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_2114,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_2112 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_2112_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_2113],
      }
    );
    const evh_1040167445267876_submit_2111 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_2112,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2111],
      }
    );
    const act_4397690859646801_script_2116 = new actions.ScriptAction(
      {
        actionArgs: this.act_4397690859646801_script_2116_getActionArgs,
        events: [],
      }
    );
    const evh_4397690859646801_blur_2115 = new actions.EventHandlerImpl(
      {
        action: act_4397690859646801_script_2116,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_4397690859646801_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_4397690859646801_blur_2115],
      }
    );
    const act_4067533979448964_script_2118 = new actions.ScriptAction(
      {
        actionArgs: this.act_4067533979448964_script_2118_getActionArgs,
        events: [],
      }
    );
    const evh_4067533979448964_blur_2117 = new actions.EventHandlerImpl(
      {
        action: act_4067533979448964_script_2118,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_4067533979448964_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_4067533979448964_blur_2117],
      }
    );
    const act_8826227742204642_script_2120 = new actions.ScriptAction(
      {
        actionArgs: this.act_8826227742204642_script_2120_getActionArgs,
        events: [],
      }
    );
    const evh_8826227742204642_blur_2119 = new actions.EventHandlerImpl(
      {
        action: act_8826227742204642_script_2120,
        event: "blur",
        displayName: "script",
      }
    );
    const evh_8826227742204642_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_8826227742204642_blur_2119],
      }
    );
    const act_1419464017721962_closeComponent_2122 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2121 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_2122,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2121],
      }
    );
    return {
      act_7315092382398562_closeModal_2108,
      evh_7315092382398562_close_2107,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2110,
      evh_2248226175642056_close_2109,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_2114,
      evh_1040167445267876_success_2113,
      act_1040167445267876_request_2112,
      evh_1040167445267876_submit_2111,
      evh_1040167445267876_submit,
      act_4397690859646801_script_2116,
      evh_4397690859646801_blur_2115,
      evh_4397690859646801_blur,
      act_4067533979448964_script_2118,
      evh_4067533979448964_blur_2117,
      evh_4067533979448964_blur,
      act_8826227742204642_script_2120,
      evh_8826227742204642_blur_2119,
      evh_8826227742204642_blur,
      act_1419464017721962_closeComponent_2122,
      evh_1419464017721962_clickPreventStop_2121,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_request_2112,
    }
  }
}

Vue.component("BatchBillingListEditor", BatchBillingListEditor);

</script>